import Pusher from 'pusher-js';
import { isString } from 'lodash-es';
import { API_KEY } from '../constants/pusher';
export function connect(channelName) {
    if (!isString(channelName)) {
        throw new Error("Invalid channel, " + channelName);
    }
    var pusher = new Pusher(API_KEY, {
        encrypted: true,
    });
    // eslint-disable-next-line no-console
    pusher.connection.bind('error', function (err) { return console.error('pusher', err); });
    var channel = pusher.subscribe(channelName);
    var unsubscribe = function () { return pusher.unsubscribe(channelName); };
    return { channel: channel, unsubscribe: unsubscribe };
}
